import { useMutation } from '../../../ReactQuery';
import { remove } from '../../../redux/api';

/**
 * Queues jobs to delete all projects in the current organization.
 */
function deleteAllProjects() {
  return remove<void, { count: number }>('/api/organization/delete-all-projects');
}

/**
 * Provides a mutation to delete all of the projects in the organization.
 */
export default function useDeleteAllProjects() {
  return useMutation({
    mutationFn: deleteAllProjects,
  });
}
